import React, { useState } from "react";
import { CardContent } from "@mui/material";
import { CardMedia, Grid, Typography, styled } from "@mui/material";
import { RootStyle } from "./style";
import { CardBox, HoverBox, CustomCard, Text, Title } from "./style";
import PharmacyImg from "../../images/platforms/pharmacy.png";
import HardwareImg from "../../images/platforms/hardware.png";
import WaterImg from "../../images/platforms/water supply.png";
import TeaImg from "../../images/platforms/tea.png";
import NestleImg from "../../images/platforms/nestle.png";
import DepartmentImg from "../../images/platforms/department.png";
import GeneralImg from "../../images/platforms/general.png";
import ClothesImg from "../../images/platforms/clothes.png";
import PlywoodImg from "../../images/platforms/plywood.png";
import ConstructionImg from "../../images/platforms/construction.png";
import FranchiseImg from "../../images/platforms/franchise.png";
import StationaryImg from "../../images/platforms/stationary.png";

export const SubTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  marginBottom: "16px",
  color: "#60656C",
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
    textAlign: "center",
  },
}));

function PlatformsSection() {
  const [selected, SetSelected] = useState(null);

  const toggle = (val = null) => {
    SetSelected(val);
  };
  return (
    <RootStyle>
      <Title sx={{ mb: { xs: "30px", md: "73px" }, textAlign: "center" }}>
        Platform optimised for your business needs
      </Title>
      <Grid container spacing="32px">
        <Grid item md={3} sm={6} xs={12}>
          {selected != 1 && (
            <CardBox onMouseEnter={() => toggle(1)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf51" }}>Pharmacy</SubTitle>
                </CardContent>
                <CardMedia sx={{ height: 310 }} image={PharmacyImg} title="" />
              </CustomCard>
            </CardBox>
          )}

          {selected == 1 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro empowers pharmacy shops to flourish by automating
                time-consuming tasks like inventory management, prescription
                processing, and financial reporting. This helps pharmacists to
                focus on patient care, build stronger relationships with
                customers, and optimise operations for profitability and
                sustainable growth.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 2 && (
            <CardBox onMouseEnter={() => toggle(2)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>
                    Stationary & Books
                  </SubTitle>
                </CardContent>
                <CardMedia
                  sx={{ height: 310 }}
                  image={StationaryImg}
                  title=""
                />
              </CustomCard>
            </CardBox>
          )}
          {selected == 2 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro helps stationary and bookshop owners conquer their
                day by streamlining inventory management, simplifying purchase
                orders, and automating accounting tasks. This empowers them to
                spend less time on paperwork and more time on what matters most:
                growing their business.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 3 && (
            <CardBox onMouseEnter={() => toggle(3)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>Hardware</SubTitle>
                </CardContent>
                <CardMedia sx={{ height: 310 }} image={HardwareImg} title="" />
              </CustomCard>
            </CardBox>
          )}
          {selected == 3 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro empowers hardware shop owners to reduce inventory
                chaos by offering stock levels, purchase orders, and accurate
                financial reports. This frees them from tedious manual tasks and
                allows them to focus on providing exceptional customer service
                and streamline their workflow.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 4 && (
            <CardBox onMouseEnter={() => toggle(4)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>Water Supply</SubTitle>
                </CardContent>
                <CardMedia sx={{ height: 310 }} image={WaterImg} title="" />
              </CustomCard>
            </CardBox>
          )}
          {selected == 4 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro equips water supply shops with the tools they need to
                thrive. By automating inventory management, streamlining
                customer billing, and generating clear financial reports, it
                empowers them to manage deliveries efficiently, and make
                data-driven decisions for sustainable growth.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 5 && (
            <CardBox onMouseEnter={() => toggle(5)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>Plywood</SubTitle>
                </CardContent>
                <CardMedia sx={{ height: 310 }} image={PlywoodImg} title="" />
              </CustomCard>
            </CardBox>
          )}
          {selected == 5 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro helps plywood shops by automating inventory tracking,
                streamlining purchase orders, and generating accurate financial
                reports. This enables less time on paperwork and more time on
                sourcing high-quality plywood, offering competitive prices, and
                growing their business with confidence.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 6 && (
            <CardBox onMouseEnter={() => toggle(6)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>
                    Construction Projects
                  </SubTitle>
                </CardContent>
                <CardMedia
                  sx={{ height: 310 }}
                  image={ConstructionImg}
                  title=""
                />
              </CustomCard>
            </CardBox>
          )}
          {selected == 6 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro empowers construction projects to thrive by
                streamlining procurement, managing budgets effectively, and
                generating project insights. This equips project managers to
                collaborate seamlessly, track progress efficiently, and make
                data-driven decisions that lead to successful completion.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 7 && (
            <CardBox onMouseEnter={() => toggle(7)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>
                    Clothes Wholesaler
                  </SubTitle>
                </CardContent>
                <CardMedia sx={{ height: 310 }} image={ClothesImg} title="" />
              </CustomCard>
            </CardBox>
          )}
          {selected == 7 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro equips clothes wholesalers by streamlining inventory
                management, automating sale and purchase orders, and generating
                insightful reports. wholesalers can focus on strengthening
                supplier relationships, identifying new market trends, and
                negotiating better deals.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 8 && (
            <CardBox onMouseEnter={() => toggle(8)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>
                    Ufone / Jazz Franchise
                  </SubTitle>
                </CardContent>
                <CardMedia sx={{ height: 310 }} image={FranchiseImg} title="" />
              </CustomCard>
            </CardBox>
          )}
          {selected == 8 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro empowers cellular service providers like Ufone and
                Jazz by streamlining employee payroll, automating sales
                tracking, and providing accurate insights into profits and
                performance. This enables them to manage payrolls, track sales,
                monitor profit margins.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 9 && (
            <CardBox onMouseEnter={() => toggle(9)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>Tea Suplier</SubTitle>
                </CardContent>
                <CardMedia sx={{ height: 310 }} image={TeaImg} title="" />
              </CustomCard>
            </CardBox>
          )}
          {selected == 9 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro helps tea suppliers to brew success by streamlining
                operations and offering insights. It automates inventory
                management, facilitates smooth order processing, and provides
                clear financial reports. This helps suppliers to focus on
                sourcing quality tea, building strong relationships with farmers
                and buyer.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 10 && (
            <CardBox onMouseEnter={() => toggle(10)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>
                    Nestle Products Suplier
                  </SubTitle>
                </CardContent>
                <CardMedia sx={{ height: 310 }} image={NestleImg} title="" />
              </CustomCard>
            </CardBox>
          )}
          {selected == 10 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro equips suppliers to deliver success with automated
                inventory management, streamlined order fulfillment, and
                insightful reporting. This frees up time to focus on sourcing
                high-quality ingredients, building strong relationships with
                clients, and exploring new market opportunities.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 11 && (
            <CardBox onMouseEnter={() => toggle(11)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>
                    Department Store
                  </SubTitle>
                </CardContent>
                <CardMedia
                  sx={{ height: 310 }}
                  image={DepartmentImg}
                  title=""
                />
              </CustomCard>
            </CardBox>
          )}
          {selected == 11 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro enables department stores to optimise operations and
                achieve retail success. By automating inventory management,
                streamlining sales processes, and providing accurate insights,
                it helps reduce costs, increase efficiency, and improve customer
                satisfaction.
              </Text>
            </HoverBox>
          )}
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {selected != 12 && (
            <CardBox onMouseEnter={() => toggle(12)}>
              <CustomCard>
                <CardContent>
                  <SubTitle sx={{ color: "#4eaf52" }}>General Store</SubTitle>
                </CardContent>
                <CardMedia sx={{ height: 310 }} image={GeneralImg} title="" />
              </CustomCard>
            </CardBox>
          )}
          {selected == 12 && (
            <HoverBox onMouseLeave={toggle}>
              <Text sx={{ pt: "16px" }}>
                ManageKaro automates inventory management, tracks sales and
                expenses, and provides insights into performance, freeing up
                time to focus on customer service, marketing, and expanding the
                product range. General stores can streamline operations, reduce
                costs, and achieve greater profitability.
              </Text>
            </HoverBox>
          )}
        </Grid>
      </Grid>
    </RootStyle>
  );
}

export default PlatformsSection;
